import User from "@/store/models/user";
import axios from "@/store/vue-axios";
import {Model} from "@/store/models/model";
import {Vserver} from "@/store/models/vserver/vserver";
import {VserverOrderList} from "@/store/models/vserver/vserver_order_list";


export class VserverOrder extends Model {

  static entity = 'vserver_order'
  static primaryKey = 'product_key'

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      hostname: this.attr(null),
      hostname_group: this.attr(null),
      type: this.attr(null),
      memory: this.attr(null),
      cores: this.attr(null),
      disk: this.attr(null),
      max_backups: this.attr(null),
      max_scheduled_tasks: this.attr(null),
      backups:this.attr(null),
      addresses_v4:this.attr(null),

      start_at_boot: this.attr(null),
      traffic: this.attr(null),
      password: this.attr(null),
      reseller_accounting: this.attr(null),

      vserver_template: this.attr(null),

      created_at: this.attr(null),
      updated_at: this.attr(null),
      username: this.attr(null),
      user: this.belongsTo(User, 'username'),
      status: this.attr(null),
      //
      product_key:this.attr(null),
      product_name:this.attr(null),
      local_change:this.attr(null),
      order_status:this.attr(null),
      selected:this.attr(null),
      default_configuration:this.attr(null),
      fix_order:this.attr(null),
      price:this.attr(null),
      amount:this.number(1)
    }
  }

  static async sendOrder(instanz){
    //return  console.log('SEND ORDER:::OK')
    console.log('SEND ORDER:::INSTANZ::',instanz)
    const x = await axios.post('/datacenter/vservers/create',instanz)
      .then(response=>{
        //insert model
        Vserver.insertOrUpdate( {data : response.data.vserver} )
        //if(VserverOrderList.find(instanz.product_key)) VserverOrderList.delete(instanz.product_key)
        return response//.status ? response.status :  {'errors':[],'warnings':[],'success':[]}
      })
      .catch(error=>{
        console.log('SEND ORDER:::error',error)
        console.log('SEND ORDER:::error',instanz.product_key)
        return {status:"error",messages:{'errors':[instanz.product_key],'warnings':[]}}
      })
    return x
  }


}

export default VserverOrder



// WEBPACK FOOTER //
// ./src/store/models/vserver/vserver_order.js